import phonebook from './phonebook';
import tracks from './tracks';
import route from './route';
import call from './call';
import chat from './chat';
import tools from './tools';
import devices from './devices';
import panel from './panel';
import settings from './settings';
import connections from './connections';

export default [
  connections,
  tracks,
  devices,
  call,
  route,
  panel,
  phonebook,
  chat,
  settings,
  tools,
];
